import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const variableCreateAtom = createMutationAtomFactory(
  'brokerage.variableCreate',
  (params: {
    name: string;
    description?: string | null;
    value: number | null;
  }) => ({
    pricingVariableCreate: {
      __args: {
        input: {
          name: params.name,
          description: params.description,
          value: params.value,
        },
      },
      id: true,
      name: true,
      description: true,
      value: true,
      timestamps: {
        createdAt: true,
        updatedAt: true,
      },
    },
  }),
);

export const variableUpdateAtom = createMutationAtomFactory(
  'brokerage.variableUpdate',
  (params: {
    id: string;
    name?: string;
    description?: string | null;
    value?: number | null;
    effectiveAt?: string;
  }) => ({
    pricingVariableUpdate: {
      __args: {
        id: params.id,
        input: {
          name: params.name,
          description: params.description,
          value: params.value,
        },
        effectiveAt: params.effectiveAt,
      },
      variable: {
        id: true,
        name: true,
        description: true,
        value: true,
        timestamps: {
          createdAt: true,
          updatedAt: true,
        },
      },
      affectedTierCount: true,
      validationErrors: {
        priceListName: true,
        priceListType: true,
        itemPricingId: true,
        tierIndex: true,
        formulaType: true,
      },
    },
  }),
);

export const variableDeleteAtom = createMutationAtomFactory(
  'brokerage.variableDelete',
  (params: { id: string }) => ({
    pricingVariableDelete: {
      __args: {
        id: params.id,
      },
    },
  }),
);
